<template>
    <section>
            <div class="container">        
                <CommonBreadcrumb class="bread_block_mod" /> 
            </div>

            <div class="container-fluid px-0">
                <div class="guide_block_banner">
                    <div class="eng_guide_banner">
                    <picture>
                    <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step_four/banner.webp">
                    <img height="540" width="1920" type="image/jpeg" src="~/assets/eng-guide/step_four/banner.jpg" alt="Complete the ring" />
                    </picture>
                    <div class="eng_guide_upper">
                        <h2>Step 4</h2>
                        <h1 class="font-active">Complete the ring</h1>
                        <p class="mb-0" v-if="$country.is_india">So you chose a budget, a diamond and a <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">ring setting</NuxtLink>. It's now time for you to complete the ring that will speak volumes about the love between you and your significant other.</p>
                        <p class="mb-0" v-else>So you chose a budget, a diamond, and a ring setting. It's now time for you to complete the ring that will speak volumes about the love between you and your significant other.</p>
                    </div>
                    </div>
                </div>
            </div>
            <div class="container-lg mt-5">
                <div class="row guide_block pb-4 align-items-center">
                <div class="col-md-5 col-12 text-left">
                    <picture>
                    <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_four/matching_band.webp">
                    <img loading="lazy" class="my-3 radious_eight" width="577" height="364" type="image/jpeg" src="~/assets/eng-guide/step_four/matching_band.jpg" alt="get a matching band" />
                    </picture>
                </div>

                <div class="col-md-7 col-12">
                    <h2 class="mb-3 font-active">get a matching band</h2>
                    <p v-if="$country.is_india">Many modern couples choose matching wedding bands to get the perfect ring stack. You can match your <NuxtLink :to="localePath('/engagement-rings')">engagement ring</NuxtLink> with a wedding band of a similar design or go for something completely different if you're feeling adventurous. Just make sure both rings pair well for that flawless stack.</p>
                    <p v-else>Many modern couples choose matching wedding bands to get the perfect ring stack. You can match your <NuxtLink :to="localePath('/engagement-rings')">engagement ring</NuxtLink> with a wedding band of a similar design or go for something completely different if you're feeling adventurous. Just make sure both the rings pair well for that flawless stack.</p>
                </div>
            </div>

            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h2 class="mb-3 font-active">personalize your ring</h2>
                    <p v-if="$country.is_india">A poignant message carved on the inside of your ring is a great way to personalise your ring. It will add a little more magic to your wedding or engagement ring. You can <NuxtLink :to="localePath('/customer-service/ring-engraving')">engrave your ring</NuxtLink> for free when you buy a custom-created ring at Friendly Diamonds.</p>
                    <p v-else>
                        A poignant message carved on the inside of your ring is a great way to <NuxtLink :to="localePath('/customer-service/ring-engraving')">personalize your ring.</NuxtLink> It will add a little more magic to your <NuxtLink :to="localePath('/blog/engagement-ring-vs-wedding-ring')">wedding or engagement ring</NuxtLink>. You can engrave your ring for free when you buy a custom-created ring at Friendly Diamonds.
                    </p>
                    <h5> Here are a few engraving Ideas :</h5>
                    <ul class="ps-4" v-if="!$country.is_india">
                        <li>A date to remember : This could be the date when you first met or your wedding date.</li>
                        <li>The name or the lyrics of the song you both love.</li>
                        <li>The initials of your names. Eg. A&J or S❤M.</li>
                        <li>The location coordinates of where the both of you first met.</li>
                    </ul>
                    <ul class="ps-4" v-else>
                        <li>A date to remember: This could be the date when you first met or your wedding date.</li>
                        <li>The name or the lyrics of the song you both love.</li>
                        <li>The initials of your names. Eg., A&J or S❤M.</li>
                        <li>The location coordinates of where the two of you first met.</li>
                    </ul>
                </div>

                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/personalise_ring.webp">
                        <img loading="lazy" class="my-3 radious_eight" width="500" height="500" type="image/jpeg" src="~/assets/eng-guide/step_four/personalise_ring.jpg" alt="personalize your ring" />
                    </picture>
                </div>
            </div>

            <div class="guide_block py-4">
                <p v-if="$country.is_india">When completing your ring, you can engrave it with your personalized message. You may not be able to do so with specific rings based on their design. The engraving can consist of alphabets and numbers. Not more than fifteen characters can be used when engraving your ring.</p>
                <p v-else>When completing your ring, you can engrave it with your personalized message. You may not be able to do so with specific rings based on their design. The engraving can consist of alphabets and numbers. Not more than fifteen characters can be used when engraving your ring.</p>
            </div>

            <div class="row guide_block pb-4 align-items-center" v-if="!$country.is_india">
                    <div class="col-md-5 col-12 text-start">
                        <picture>
                            <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/appraise.webp">
                            <img loading="lazy" class="my-3 radious_eight" width="500" height="500" type="image/jpeg" src="~/assets/eng-guide/step_four/appraise.jpg" alt="appraising your ring">
                        </picture>
                    </div>
                    
                    <div class="col-md-7 col-12">
                        <h2 class="mb-3 font-active">appraising your ring</h2>
                        <p v-if="$country.is_india">
                            You can get your ring appraised by a reputable third-party institution to know the exact value of your ring. You shall receive an appraisal certificate that tells you the precise value of your ring as per the current market rate for just 50 USD. You can then present the valuation certificate to your insurance company to insure your ring for theft and loss.
                            <br><br>
                            You also get a diamond certificate from reputed diamond certification institutions like GIA, IGI and GCAL which authenticates the diamond you purchase. We also offer a lifetime warranty as we believe in standing behind all of our pieces and assure the consumer of the best quality.
                        </p>
                        <p v-else>
                            You can get your ring appraised by a reputable third party institution to know the exact value of your ring. You shall receive an appraisal certificate that tells you the precise value of your ring as per the current market rate for just 50 USD. You can then present the valuation certificate to your insurance company to insure your ring for theft and loss.
                            <br><br>
                            You also get a diamond certificate from reputed <NuxtLink :to="localePath('/blog/igi-certificate-vs-gia-certified-diamonds')">diamond certification</NuxtLink> institutions like <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">GIA</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">IGI</NuxtLink> and GCAL which authenticates the diamond you purchase. We also offer a lifetime warranty as we believe in standing behind all of our pieces and assure the consumer of the best quality.
                        </p>
                    </div>
            </div>
        
            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h2 class="mb-3 font-active">get the perfectly sized ring</h2>
                    <p v-if="$country.is_india">
                        Your engagement ring should be a snug fit, not too tight, but also not too loose. An ideal engagement ring fits loose enough to slide smoothly over your knuckles and tight enough so it doesn't fall off your finger.
                        <br><br>
                        For ladies, the standard <NuxtLink :to="localePath('/how-to-find-ring-size')">ring size</NuxtLink> varies from 3 to 9. Sizes 5 to 7 are the most commonly purchased, with size 6 being the most frequent.
                        <br><br>
                        For men, sizes 6 to 13 are the typical ring size ranges. Sizes 8 to 10-½ are most commonly purchased, with size 9 being the most frequent.
                        <br><br>
                        Here are a few ways to measure your ring size
                    </p>
                    <p v-else>
                        Your engagement ring should be a snug fit, not too tight, but also not too loose. An ideal engagement ring fits loose enough to slide smoothly over your knuckle and tight enough so it doesn't fall off your finger.
                        <br><br>
                        For ladies, the standard <NuxtLink :to="localePath('/how-to-find-ring-size')">ring size</NuxtLink> varies from 3 to 9. Sizes 5 to 7 are the most commonly purchased, with size 6 being the most frequent.
                        <br><br>
                        For men, sizes 6 to 13 are the typical ring size ranges. Sizes 8 to 10-½ are most commonly purchased, with size 9 being most frequent.
                        <br><br>
                        Here are a few ways to measure your <NuxtLink :to="localePath('/how-to-find-ring-size')">ring size</NuxtLink>.
                    </p>
                </div>

                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/sized_ring.webp">
                        <img loading="lazy" class="my-3 radious_eight" height="500" width="500" type="image/jpeg" src="~/assets/eng-guide/step_four/sized_ring.jpg" alt="get the perfectly sized ring">
                    </picture>
                </div>
            </div>

            <div class="row guide_block pb-4 align-items-center">
                <div class="col-md-5 col-12 text-left">
                    <picture>
                    <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/ring_size.webp">
                    <img loading="lazy" class="my-3 radious_eight" height="500" width="500" type="image/jpeg" src="~/assets/eng-guide/step_four/ring_size.jpg" alt="Measure your ring size with string/thread & ruler at home">
                    </picture>
                </div>

                <div class="col-md-7 col-12">
                    <h5>Method 1</h5>
                    <h4 class="mb-3 font-active">Measure your ring size with string/thread & ruler at home</h4>
                    <h5>Follow these steps :</h5>
                    <ul class="ps-4" v-if="$country.is_india">
                        <li>Take the string or thread piece and circle it around the base of your finger.</li>
                        <li>Use a pen and mark the string or thread's meeting point.</li>
                        <li>Take the measurement of the thread or string in mm using a ruler.</li>
                        <li>Choose the nearest measurement provided in the ring size chart to know your ring size.</li>
                    </ul>
                    <ul class="ps-4" v-else>
                        <li>Take the string or thread piece and circle it around the base of your finger.</li>
                        <li>Use a pen and mark the string or thread's meeting point.</li>
                        <li>Take the measurement of the thread or string in mm using a ruler.</li>
                        <li>Choose the nearest measurement provided in the ring size chart to know your ring size.</li>
                    </ul>
                    <h5>Conversion Chart</h5>
                    <CommonSizeChartIndia v-if="$country.is_india" />
                    <CommonSizeChart v-else  />
                </div>
            </div>

            <div class="guide_block py-4 align-items-center">
                <h5>Some tips to keep in mind :</h5>
                <ul class="ps-4" v-if="$country.is_india">
                   <li> If your knuckle is larger than the base of your finger, you must measure both the spots and choose a size between both the measurements.</li>
                    <li>  Always assess your ring size with warm fingers. Your ring size can change based on daytime and weather conditions. For example, early mornings and chilly weather can lead to shrinking fingers, making it a not-so-ideal time to measure your finger ring size. Also, note that your dominant hand has larger fingers.</li>
                    <li>Measure your ring finger more than once for accuracy.</li>
                </ul>
                <ul class="ps-4" v-else>
                    <li> If your knuckle is larger than the base of your finger, you must measure both the spots and choose a size between both the measurements.</li>
                    <li>Always assess your ring size with warm fingers. Your ring size can change based on daytimes and weather conditions. For example, early mornings and chilly weather can lead to shrinking fingers, making it a not-so-ideal time to measure your finger ring size. Also, note that your dominant hand has larger fingers.</li>
                    <li>Measure your ring finger more than once for accuracy.</li>
                </ul>
            </div>

            <div class="row guide_block pb-4 align-items-center" v-if="$country.is_india">
                <div class="col-md-7 col-12">
                    <h5>Method 2</h5>
                    <h4 class="mb-3 font-active">Measure an existing ring</h4>
                    <ul class="ps-4" v-if="$country.is_india">
                       <li> Measure the inside of another ring that fits you comfortably using a measuring tape.</li>
                        <li>You must ensure that the ring fits your finger comfortably. It should be as tight as not to fall from your finger but loose enough to glide over your knuckle easily.</li>
                    </ul>
                    <ul class="ps-4" v-else>
                        <li>Measure the inside of another ring that fits you comfortably using a measuring tape.</li>
                        <li>You must ensure that the ring fits your finger comfortably. It should be as tight as not to fall from your finger but loose enough to glide over your knuckle easily.</li>
                    </ul>
                </div>

                <div class="col-md-5 col-12 text-left">
                    <picture>
                    <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/existing_ring.webp">
                    <img class="my-3" height="500" width="500" type="image/jpeg" src="~/assets/eng-guide/step_four/existing_ring.jpg" alt="Measure an existing ring">
                    </picture>
                </div>
            </div>

            <div class="row guide_block pb-4 align-items-center" v-if="!$country.is_india">
              <div class="col-md-5 col-12 text-left">
                <picture>
                    <source width="500" height="500" type="image/webp" srcset="~/assets/eng-guide/step_four/existing_ring.webp">
                    <img  class="my-3 radious_eight" height="500" width="500" type="image/jpeg" src="~/assets/eng-guide/step_four/existing_ring.jpg" alt="Measure an existing ring">
                </picture>
              </div>

              <div class="col-md-7 col-12">
                <h5>Method 2</h5>
                <h4 class="mb-3 font-active">Measure an existing ring</h4>
                <ul class="ps-4" v-if="$country.is_india">
                    <li> Measure the inside of another ring that fits you comfortably using a measuring tape.</li>
                     <li>You must ensure that the ring fits your finger comfortably. It should be as tight as not to fall from your finger but loose enough to glide over your knuckle easily.</li>
                 </ul>
                 <ul class="ps-4" v-else>
                    <li>Measure the inside of another ring that fits you comfortably using a measuring tape.</li>
                    <li>You must ensure that the ring fits your finger comfortably. It should be as tight as not to fall from your finger but loose enough to glide over your knuckle easily.</li>
                </ul>
              </div>
            </div>

            <div class="guide_block py-4 align-items-center">
                <h2 class="font-active">Tips for buying a ring as a surprise</h2>
                <p v-if="$country.is_india">If you're planning a surprise for them, get help from friends and family. They can ask without raising any eyebrows. Tell them to keep it hush-hush, so they don't accidentally ruin the surprise! You can also borrow your partner’s ring (make sure it's worn on the correct finger!) and use the <NuxtLink :to="localePath('/customer-service/ring-resizing')">ring sizing</NuxtLink> tips mentioned above.</p>
                <p v-else>If you're planning a surprise for them, get help from friends and family. They can ask without raising any eyebrows.. Tell them to keep it hush-hush, so they don't accidentally ruin the surprise! You can also borrow your partner’s ring (make sure it's worn on the correct finger!) and use the ring sizing tips mentioned above.</p>
            </div>

            <div class="row cta_block">
                <div class="col-md-12 col-12 mx-auto px-0 d-flex align-items-center justify-content-center font-active">
                    <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')">
                        Choose A Diamond <div class="arrow_eng">
                            <SvgHeaderSvg :type="'left'" /></div> Back
                    </NuxtLink>
                    <span>|</span>
                    <NuxtLink :to="localePath('/engagement-ring-guide/time-to-propose')">
                        Next <div class="arrow_eng">
                            <SvgHeaderSvg :type="'right'" /></div> Time To Propose
                    </NuxtLink>
                </div>
            </div>
        </div> 
    </section>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.arrow_eng .svg-head {
    height: 13px;
    width: 12px;
    margin: 0 10px;
}
.eng_guide_banner {
    position: relative;
}
.eng_guide_upper {
    position: absolute;
    top: 50%;
    left: 20%;
    width: 25%;
    transform: translate(-50%,-50%);
}
 .eng_guide_upper h2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h1 {
    font-size: 32px;
    color: var(--green);
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h1 span{
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    color: #000;
    display: block;
    font-family: Lato;
    margin-bottom: 2%;
}
.eng_guide_upper p {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 1.8;
}
.eng_guide_flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.eng_guide_flex a {
    display: inline-block;
    font-size: 14px;
    padding: 1.5% 5%;
    color: #000;
    text-transform: unset;
    font-weight: 400;
    border: 1px solid #000;
}
/* -------cta */
.row.cta_block a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 18px;
}
.row.cta_block span {
    font-size: 25px;
    margin: 0 15px;
    font-weight: 300;
}
.row.cta_block {
    margin: 4% 0;
}
/* -------cta */
@media(max-width:1350px ){
    .eng_guide_upper{
        width: 50%;
        left: 30%;
    }
}
@media(max-width:1024px ){
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .eng_guide_banner img {
        height: 45vh;
        object-fit: cover;
        object-position: 100%;
    }
}
@media(max-width:992px ){
    .eng_guide_banner img{
        display: none;
    }
    .eng_guide_upper {
        width: 100%;
        left: 0;
        transform: unset;
        position: relative;
        top: 0;
    }
    .guide_block_banner {
        padding: 0 36px 5% 36px;
        border-bottom: 1px solid #ccc;
    }
     /* -------cta */
     .row.cta_block a {
        font-size: 16px;
    }
    /* -------cta */
}
@media(max-width:767px ){
    .arrow_eng {
        /* font-size: 40px; */
    }
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .guide_block_banner {
        padding: 0% 18px 8% 18px;
        border-bottom: 1px solid #ccc;
    }
    .eng_guide_flex {
        flex-wrap: wrap;
    } 
    .eng_guide_flex a {
        display: block;
        width: 100%;
        margin: 2% 0 !important;
        text-align: center;
    }
    /* -------cta */
    .row.cta_block a {
        font-size: 14px;
    }
    /* -------cta */
}
/* -------------------------------------------------------------- */

.guide_block h2 {
    font-size: 32px;
    text-transform: capitalize;
    color: var(--green);
}
.guide_block h5 {
    font-size: 16px;
    font-weight: 600;
    color: #6a6161;
}

.guide_block h4 {
    font-size: 26px;
    text-transform: capitalize;
}
 h6 {
    text-align: center;
    font-size: 32px;
    padding: 5%;
    color: #6a6161;
}
.guide_block h4 span{
    color: var(--green);
}
.guide_block p {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
.guide_block p a {
    background: none;
    padding: 0;
    font-size: 16px;
    text-transform: unset;
    color: #6a6161;
    font-weight: 500;
    border: 0;
    text-decoration: underline;
    color: var(--green);
}
.guide_block h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--green);
}
.guide_block a {
    display: inline-block;
    font-size: 14px;
    padding: 10px 20px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
}
.guide_block ul li {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
@media(max-width: 992px){
    .guide_block h2 {
        font-size: 26px;
    }
    h6 {
        font-size: 24px;
    }
}

@media(max-width: 767px){
    .row_mod {
        flex-direction: column-reverse;
    }

    .guide_block h2 {
        font-size: 24px;
    }
    .guide_block h4{
        font-size: 24px;
    }
    .guide_block p {
        margin: 3% 0 !important;
    }
  
    .guide_block h3 {
        font-size: 16px;
    }
  
    h6 {
        font-size: 18px;
        padding: 5% 0;
    }
}
</style>
